module.exports = __webpack_public_path__ + "img/list_Story_12.adb8b535.jpeg";